export function stickyHeader() {
    let header = document.querySelector(".header");

    function stickyHeaderOnScroll() {
        if (window.scrollY < 20) {
            header.classList.remove("sticky");
        }
        const currentScroll = window.scrollY;
        if (currentScroll > 20) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }


    window.addEventListener("load", () => {
        stickyHeaderOnScroll();
    });

    window.addEventListener("scroll", stickyHeaderOnScroll);

}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js